import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['row', 'checkbox', 'quantity'];

  toggleRow(event: Event) {
    const checkbox = event.currentTarget as HTMLInputElement;
    const row = checkbox.closest('[data-items--harvested-parts-target="row"]') as HTMLElement | null;
    if (!row) return;

    const quantity = row.querySelector('[data-items--harvested-parts-target="quantity"]') as HTMLInputElement | null;
    if (!quantity) return;

    quantity.disabled = !checkbox.checked;
    if (checkbox.checked && (!quantity.value || quantity.value === '0')) {
      quantity.value = '1';
    }
  }
}
